<div class="navbar-content" fusePerfectScrollbar [fusePerfectScrollbarOptions]="{ suppressScrollX: true }" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>
